<template>
  <div>
    <v-chip
      :append-icon="chipIcon"
      :color="chipColor"
      label
      small
    >
      <div class="d-flex">
        <span class="texte --text-white align-self-center pr-1">
          {{ etatLogistique.libelle | capitalize }}
        </span>
        <v-icon
          color="white"
        >
          {{ chipIcon }}
        </v-icon>
      </div>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'StatutLivraisonChip',
  props: {
    etatLogistique : {
      type: Object,
      required: true
    }
  },

  computed: {
    chipColor () {
      switch(this.etatLogistique.code) {
        case 'A_LIVRER':
          return '#EC6608'
        case 'EN_COURS_LIVRAISON':
          return '#DBBD00'
        case 'LIVRE':
          return '#01713C'
        default:
          return 'grey'
      }
    },

    chipIcon () {
      switch(this.etatLogistique.code) {
        case 'EN_COURS_LIVRAISON':
          return 'mdi-progress-helper'
        case 'LIVRE':
          return 'mdi-check'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
